import { Link } from "react-router";
import { useEffect } from "react";
import Spinner from "../../components/ui/spinner";
import DynamicTable from "../../components/tables/DynamicTable";
import Button from "../../components/ui/button/Button";
import useRestaurants from '../../hooks/Restaurant/useRestaurants'

const columns = [
  "id",
  "img",
  "name",
  "phone",
  "website",
  "menus",
  "editAction"
]

const RestaurantList = () => {
  const { restaurants, loading, error, refetchRestaurants } = useRestaurants({
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
    
  useEffect(() => {
    refetchRestaurants();
  }, [refetchRestaurants]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      <DynamicTable data={restaurants} columns={columns} rowKey="restaurants" initialPageSize={100} />
      <Link to="/restaurants/new">
        <Button 
          size="md" 
          variant="primary"
          className="my-6"
        >
          New
        </Button>
      </Link>
    </>  
  )
}

export default RestaurantList;
